import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e83fb56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CurrentAddress = _resolveComponent("CurrentAddress")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_information = _resolveComponent("information")!
  const _component_user_menu = _resolveComponent("user-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_home_head),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_CurrentAddress, null, {
                    address: _withCtx(() => [
                      _hoisted_4,
                      _createTextVNode(" >  "),
                      _createVNode(_component_router_link, { to: {
                    name: 'user',
                  } }, {
                        default: _withCtx(() => [
                          _createTextVNode("个人中心")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_container, { class: "contents user-contents" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_aside, null, {
                default: _withCtx(() => [
                  _createVNode(_component_information),
                  _createVNode(_component_user_menu)
                ]),
                _: 1
              }),
              _createVNode(_component_el_main, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_html_footer)
  ], 64))
}